// Typelizer digest 1963e881f0cee50a66f7d64a911fecff
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** DELETE /c/:company_id/ledger/documents/:document_id/verification */
  destroy: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/verification', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/ledger/documents/:document_id/verification */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/verification', params, options),
    method: 'post',
  }),
}
